import type { Language } from "@/data/model/Enums";
import type { ICurrentIdentityService } from "@/data/services/CurrentIdentityService";

import { clientLanguage } from "@/shared/localization/language";

import { TastierGlobal } from "@/portal/globalAccess";

export class PortalCurrentIdentityService implements ICurrentIdentityService {
    public getIdentityId(): string | undefined {
        return TastierGlobal?.getIdentity()?.userId;
    }

    public getLanguage(): Language {
        return TastierGlobal?.getIdentity()?.lang ?? clientLanguage();
    }
}
